import {useBleskAuth, useTeamSubscription} from '@blesk-frontend/auth';
import {cn, getMotionProps} from '@blesk-frontend/ui';
import {Link} from '@tanstack/react-router';
import {AnimatePresence, motion} from 'motion/react';
import {useMemo} from 'react';

import {PlanProBadge} from '@/features/plans';
import {sendEvent} from '@/libs/analytics';

const rootMotionProps = getMotionProps({
  initial: {y: 8, opacity: 0},
  animate: {y: 0, opacity: 1},
  exit: {y: 8, opacity: 0},
});

const dividerMotionProps = getMotionProps(
  {
    initial: {opacity: 0},
    animate: {opacity: 1},
    exit: {opacity: 0},
  },
  {delay: 0.08},
);

export const AppSidebarPremium = () => {
  const {
    discounts,
    subscription,
    freeLimits,
    isLoading: isTeamSubscriptionLoading,
  } = useTeamSubscription();

  const {
    query: {data: user},
  } = useBleskAuth();

  const isOwner = useMemo(() => {
    return user?.teams.at(0)?.role === 'owner';
  }, [user]);

  const welcomeDiscount = useMemo(() => {
    return discounts?.find((discount) => discount.code === 'welcome');
  }, [discounts]);

  const onClickLink = () => {
    if (welcomeDiscount) {
      sendEvent('billing/discount:sidebar-click', {discountId: welcomeDiscount.id});
    }
  };

  if (isTeamSubscriptionLoading) {
    return null;
  }

  return (
    <AnimatePresence>
      {!subscription && (
        <motion.div {...rootMotionProps} className="flex flex-col gap-6 text-paragraph-sm">
          <motion.div {...dividerMotionProps} className="border-b" />

          <div className="text-center text-paragraph-sm text-text-secondary">
            Создано инструкций
            <br />в текущем месяце
            <br />
            <span>
              {freeLimits?.current} из {freeLimits?.limit}
            </span>
          </div>

          <div className="flex flex-col items-center justify-center gap-4 rounded-md border border-border-primary p-4 text-center">
            <PlanProBadge />
            <div className="text-paragraph-sm text-text-secondary">
              Создавайте любое количество инструкций и получите больше функций c тарифом Pro
            </div>

            {!!welcomeDiscount && (
              <Link
                className={cn(
                  'glare rounded-md bg-brand-primary p-2 text-center text-text-contrast transition-all',
                  'hover:bg-brand-primary/80',
                )}
                to="/plans"
                onClick={onClickLink}
              >
                Получите скидку {welcomeDiscount.discount}% при покупке подписки до{' '}
                {new Date(welcomeDiscount.expiresAt).toLocaleDateString('ru-RU')}
              </Link>
            )}

            {isOwner && (
              <Link
                className="text-brand-primary text-paragraph-sm"
                to="/plans"
                onClick={onClickLink}
              >
                <span>Перейти к тарифам</span>
              </Link>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
